import { Component, OnDestroy, Input } from '@angular/core';
import { NbLayoutDirectionService, NbLayoutDirection } from '@nebular/theme';
import { takeWhile } from 'rxjs/operators';
import { AnalyticsService } from '@res/ngg-core';
import { SwitcherComponent } from '../switcher/switcher.component';

@Component({
  standalone: true,
  selector: 'nggt-layout-direction-switcher',
  template: `
    <nggt-switcher
      [firstValue]="directions.RTL"
      [secondValue]="directions.LTR"
      [firstValueLabel]="'RTL'"
      [secondValueLabel]="'LTR'"
      [value]="currentDirection"
      (valueChange)="toggleDirection($event)"
      [vertical]="vertical"
    >
    </nggt-switcher>
  `,
  imports: [SwitcherComponent],
  providers: [AnalyticsService, NbLayoutDirectionService],
})
export class LayoutDirectionSwitcherComponent implements OnDestroy {
  directions = NbLayoutDirection;
  currentDirection: NbLayoutDirection;
  alive = true;

  @Input() vertical = false;

  constructor(
    private directionService: NbLayoutDirectionService,
    private analyticsService: AnalyticsService,
  ) {
    this.currentDirection = this.directionService.getDirection();

    this.directionService
      .onDirectionChange()
      .pipe(takeWhile(() => this.alive))
      .subscribe((newDirection) => (this.currentDirection = newDirection));
  }

  toggleDirection(newDirection: string) {
    this.directionService.setDirection(newDirection as NbLayoutDirection);

    this.analyticsService.trackEvent('toggle_direction', { newDirection });
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
